<template>
  <data-table
    :headers="headers"
    :data="items"
    :hide-table-bottom="true"
    :hide-edit="true"
    :hide-delete="true"
    :expand-component="ExpandComponent"
    :show-expand="true"
    :loading="loading"
  />
</template>

<script>
import DataTable from '@/app/arch/components/data-table/DataTable.vue';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ConciliationPendingTransferList from 'Modules/contacard/conciliations/transfer/conciliation/components/ConciliationPendingTransferList.vue';
import ConciliationModalBtnVue from './ConciliationModalBtn.vue';

export default {
  name: 'SuggestionList',
  components: { DataTable },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    ExpandComponent: ConciliationPendingTransferList,
    headers: [
      {
        text: 'Cliente',
        value: 'clientName',
      },
      {
        text: 'Documento',
        value: 'clientDocument',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Nome do banco',
        value: 'bankAccount.bankName',
      },
      {
        text: 'Código do banco',
        value: 'bankAccount.bankCode',
      },
      {
        text: 'Agência',
        value: 'bankAccount.agency',
      },
      {
        text: 'Número da conta',
        value: 'bankAccount.accountNumber',
      },
      {
        text: 'Dígito verificador',
        value: 'bankAccount.accountVerificationDigit',
      },
      {
        text: 'Data da sugestão',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Ação',
        value: 'id',
        component: ConciliationModalBtnVue,
      },
    ],
  }),
  computed: {
    items() {
      return this.value;
    },
  },
  provide() {
    return {
      handleColumnValue: (v) => {
        if (!v) {
          return 'Não retornado';
        }
        return v;
      },
    };
  },
};
</script>
